// extracted by mini-css-extract-plugin
module.exports =  {"drawer":"FloatingDrawer-module__drawer___NISB8"};